export default __webpack_public_path__ + "static/media/no_profile.2437ff51.svg";